import { gql } from "graphql-tag"

const typeCustomerAddress = gql`
  type CustomerAddressLong {
    id: ID
    additionalAddressInfo: String
    additionalStreetInfo: String
    apartment: String
    building: String
    city: String
    company: String
    country: String
    department: String
    email: String
    fax: String
    firstName: String
    lastName: String
    mobile: String
    pOBox: String
    phone: String
    postalCode: String
    region: String
    salutation: String
    state: String
    streetName: String
    title: String
    customFields: AddressLongCustomFields
    isDefaultShipping: Boolean
    isDefaultBilling: Boolean
    isCustomerContact: Boolean
    isBillingAddress: Boolean
    isShippingAddress: Boolean
    customerId: ID
  }

  type AddressLongCustomFields {
    benefitRecipient: Boolean
    creationBy: String
    creationAt: DateTime
    modifiedBy: String
    modifiedAt: DateTime
    status: String
    versionNr: String
    dateOfBirth: String
  }

  type CustomerAddresses {
    total: Int
    items: [CustomerAddressLong]
  }

  input AddressLongCustomFieldsValues {
    benefitRecipient: Boolean
    status: Status
    dateOfBirth: String
  }

  input AddressValues {
    country: String!
    title: String
    salutation: String
    firstName: String
    lastName: String
    streetName: String
    additionalStreetInfo: String
    postalCode: String
    city: String
    region: String
    state: String
    company: String
    department: String
    building: String
    apartment: String
    pOBox: String
    phone: String
    mobile: String
    email: String
    fax: String
    additionalAddressInfo: String
    customFields: AddressLongCustomFieldsValues
  }

  type Query {
    customerAddress(
      customerId: ID
      customerNumber: String
      customerKey: String
      addressId: ID!
    ): CustomerAddressLong
    customerShippingAddresses(
      customerId: ID
      customerNumber: String
      customerKey: String
    ): CustomerAddresses
    customerBillingAddresses(
      customerId: ID
      customerNumber: String
      customerKey: String
    ): CustomerAddresses
    customerContactAddresses(
      customerId: ID
      customerNumber: String
      customerKey: String
    ): CustomerAddresses
    customerAllAddresses(
      customerId: ID
      customerNumber: String
      customerKey: String
    ): CustomerAddresses
  }

  enum Status {
    DELETED
    CLOSED
    ACTIVE
  }
  enum AddressType {
    BILLING
    SHIPPING
    CONTACT
  }

  type Mutation {
    setCustomerAddressStatus(
      customerId: ID
      customerKey: String
      customerNumber: String
      addressId: ID!
      status: Status
    ): CustomerAddressLong

    setDefaultShippingAddress(
      customerId: ID
      customerNumber: String
      customerKey: String
      addressId: ID!
    ): CustomerAddressLong

    removeDefaultShippingAddress(
      customerId: ID
      customerNumber: String
      customerKey: String
      addressId: ID!
    ): CustomerAddressLong

    setDefaultBillingAddress(
      customerId: ID
      customerNumber: String
      customerKey: String
      addressId: ID!
    ): CustomerAddressLong

    removeDefaultBillingAddress(
      customerId: ID
      customerNumber: String
      customerKey: String
      addressId: ID!
    ): CustomerAddressLong

    createCustomerAddress(
      addressType: AddressType!
      customerId: ID
      customerNumber: String
      customerKey: String
      values: AddressValues
    ): CustomerAddressLong

    updateCustomerAddress(
      customerId: ID
      customerNumber: String
      customerKey: String
      addressId: ID!
      values: AddressValues
    ): CustomerAddressLong
  }
`

export { typeCustomerAddress }

export default typeCustomerAddress
